(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement"] && !Shopify.designMode) return;
  try {
    (function(){
    function nthWeekday(year, month, weekday, n) {
      var d = new Date(year, month, 1);
      var offset = (weekday - d.getDay() + 7) % 7;
      d.setDate(1 + offset + (n - 1) * 7);
      return d;
    }
    function lastWeekday(year, month, weekday) {
      var d = new Date(year, month + 1, 0);
      var offset = (d.getDay() - weekday + 7) % 7;
      d.setDate(d.getDate() - offset);
      return d;
    }
    function endOfDay(d) {
      var e = new Date(d);
      e.setHours(23, 59, 59, 999);
      return e;
    }
    function buildHolidays(year) {
      var thanksgiving = nthWeekday(year, 10, 4, 4);
      var blackFriday = new Date(thanksgiving);
      blackFriday.setDate(blackFriday.getDate() + 1);
      var cyberMonday = new Date(thanksgiving);
      cyberMonday.setDate(cyberMonday.getDate() + 4);
      return [
        { name: "NEW YEAR", date: new Date(year, 0, 1) },
        { name: "VALENTINE'S DAY", date: new Date(year, 1, 14) },
        { name: "PRESIDENTS DAY", date: nthWeekday(year, 1, 1, 3) },
        { name: "ST. PATRICK'S DAY", date: new Date(year, 2, 17) },
        { name: "MEMORIAL DAY", date: lastWeekday(year, 4, 1) },
        { name: "4TH OF JULY", date: new Date(year, 6, 4) },
        { name: "LABOR DAY", date: nthWeekday(year, 8, 1, 1) },
        { name: "HALLOWEEN", date: new Date(year, 9, 31) },
        { name: "VETERANS DAY", date: new Date(year, 10, 11) },
        { name: "BLACK FRIDAY", date: blackFriday },
        { name: "CYBER MONDAY", date: cyberMonday },
        { name: "CHRISTMAS", date: new Date(year, 11, 25) },
        { name: "NEW YEAR'S EVE", date: new Date(year, 11, 31) }
      ];
    }
    function nextHoliday(now, lookaheadDays) {
      var candidates = buildHolidays(now.getFullYear()).concat(buildHolidays(now.getFullYear() + 1));
      var best = null;
      candidates.forEach(function (h) {
        var deadline = endOfDay(h.date);
        if (deadline >= now) {
          var daysOut = (deadline - now) / 86400000;
          if (daysOut <= lookaheadDays && (!best || deadline < best.deadline)) {
            best = { name: h.name, deadline: deadline };
          }
        }
      });
      return best;
    }
    function fallbackSale(now) {
      var d = new Date(now);
      var untilSunday = (7 - d.getDay()) % 7;
      d.setDate(d.getDate() + untilSunday);
      return { name: "FLASH SALE", deadline: endOfDay(d) };
    }
    function pad(n) { return String(n).padStart(2, "0"); }

    function initSlot(slot){
      var labelEl = slot.querySelector(".hrx-urgency-label");
      var timeEl = slot.querySelector(".hrx-urgency-time");
      if (!labelEl || !timeEl) return;

      var LOOKAHEAD_DAYS = 21;

      function tick() {
        var now = new Date();
        var holiday = nextHoliday(now, LOOKAHEAD_DAYS) || fallbackSale(now);
        labelEl.textContent = holiday.name + " SAVINGS";

        // Timer always counts down to midnight tonight (resets daily), so
        // it never shows a triple-digit hour count even when the real
        // holiday is several days out — matches the iRestore/Mamaearth pattern.
        var diff = endOfDay(now) - now;
        var hours = Math.floor(diff / 3600000);
        var mins = Math.floor((diff % 3600000) / 60000);
        var secs = Math.floor((diff % 60000) / 1000);
        timeEl.textContent = hours + "H " + pad(mins) + "M " + pad(secs) + "S";
      }
      tick();
      setInterval(tick, 1000);
    }

    document.querySelectorAll(".hrx-urgency-slot").forEach(initSlot);
  })();
  } catch(e) { console.error(e); }
})();

})();
